/**
 * Hashtag prefixes that identify community-local posts.
 *
 * Do not include the leading #. ATProto hashtag facet values
 * are represented without it.
 *
 * Matching should be case-insensitive.
 */
export const LOCAL_TAG_PREFIXES = ['gv-', 'os-', 'hg-'] as const
export const LOCAL_TAG_DEFAULTS: Record<
  (typeof LOCAL_TAG_PREFIXES)[number],
  string
> = {
  'gv-': 'gv-general',
  'os-': 'os-general',
  'hg-': 'hg-general',
}
